export enum NotificationType {
  Shipment = 'SHIPMENT'
}
